const checkLastStep = list => {
  let check = [];
  check = list.filter(item => item.isActive && (item.reason || item.additionalList));
  return check && check.length;
};

export default {
  setActiveStep(state, payload) {
    state.activeStep = payload;
  },
  setType(state, payload) {
    state.type = payload;
    state.activeStep = payload ? Math.max(1, state.activeStep) : 0;
  },
  setDocument(state, payload) {
    state.document = payload;
    state.activeStep = 2;
  },
  clearComplaintList(state) {
    state.list = [];
  },
  clearDocument(state) {
    state.activeStep = 1;
    state.document = undefined;
  },
  toggleProductComplaint(state, { position, complaintedAmount }) {
    if (state.list.find(item => item.position === position))
      state.list = state.list.map(item =>
        item.position === position ? { ...item, isActive: !item.isActive } : item,
      );
    else
      state.list.push({
        position,
        isActive: true,
        attachments: [],
        reason: '',
        additionalList: '',
        amount: complaintedAmount,
      });
    if (checkLastStep(state.list)) state.activeStep = 3;
    else state.activeStep = 2;
  },
  setAttachments(state, { position, attachments }) {
    if (state.list.find(item => item.position === position)) {
      state.list = state.list.map(item =>
        item.position === position ? { ...item, attachments } : item,
      );
    }
  },
  setReason(state, { position, reason, additionalList, serialNumber, attachments, deviceModel }) {
    if (state.list.find(item => item.position === position)) {
      state.list = state.list.map(item =>
        item.position === position
          ? { ...item, reason, additionalList, serialNumber, attachments, deviceModel }
          : item,
      );
    }
    if (checkLastStep(state.list)) state.activeStep = 3;
    else state.activeStep = 2;
  },
  setAmount(state, { position, amount }) {
    if (state.list.find(item => item.position === position)) {
      state.list = state.list.map(item =>
        item.position === position ? { ...item, amount } : item,
      );
    }
  },
  clearData(state) {
    state.activeStep = 0;
    state.type = undefined;
    state.document = undefined;
    state.ordersString = '';
    state.orders = [];
    state.ordersSearchResult = [];
    state.list = [];
  },
  setFilter(state, { name, value }) {
    state.activeFilters = { ...state.activeFilters, [name]: value };
  },
  fetchComplaints() {},
  setAutocompleteSource(state, payload) {
    state.autocompleteSource = payload;
  },
  setOrdersString(state, payload) {
    state.ordersString = payload;
  },
  setIsLoadingOrders(state, payload) {
    state.isLoadingOrders = payload;
  },
  setOrders(state, payload) {
    if (payload.length) {
      state.orders = payload;
    } else {
      state.orders = [];
    }
  },
  setLastOrders(state, payload) {
    if (payload.length) {
      state.lastOrders = payload;
    } else {
      state.lastOrders = [];
    }
  },
  setOrdersSearchResult(state, payload) {
    if (payload.length) {
      state.ordersSearchResult = payload;
    } else {
      state.ordersSearchResult = [];
    }
  },
};
